import { isUndefined } from 'lodash-es';
import { env } from '../config';
import type { AppLocale } from '../i18n';

export interface AppContext {
  locale: AppLocale;
  isWebview: boolean;
}

let appContext: AppContext;

export function createAppContext(pageContext: {
  locale: AppLocale;
  isMobile: boolean;
  isWebview: boolean;
}) {
  const { locale, isWebview } = pageContext;

  appContext = {
    locale,
    isWebview: Boolean(isWebview),
  };

  return appContext;
}

export const appContextSymbol = Symbol('app-context');

export function getAppContext() {
  if (env.IS_SSR) {
    throw new Error(
      '"getAppContext" should not be called in SSR environment to avoid cross request pollution.',
    );
  }

  if (isUndefined(appContext)) {
    throw new Error(
      '"app context" is not defined yet. Forgot to call createAppContext(pageContext)?',
    );
  }

  return appContext;
}
